/**
 * Track Class
 * Represents a single audio track with metadata and audio processing nodes
 */
export class Track {
  constructor(id) {
    this.id = id;
    this.audioBuffer = null;
    this.waveformData = null;
    this.timeOffset = 0; // Time offset in seconds (computed from sampleOffset)
    this.sampleOffset = 0; // Sample offset in this track's sample rate (source of truth)
    this.pixelOffset = 0;
    this.originalSampleRate = null; // Original file sample rate (before browser resampling)
    this.gainNode = null; // Volume control (linear 0-1)
    this.preGainNode = null; // Gain control (dB boost/cut)
    this.compressorNode = null;
    this.panNode = null;
    this.fileName = "";
    this.color = "#2196F3";
    this.volume = 1.0; // Per-track volume (0.0 to 1.0)
    this.gain = 0; // Pre-gain in dB (-40 to +40)
    this.pan = 0; // Stereo pan (-1 = left, 0 = center, 1 = right)
    this.useCompressor = false; // Enable/disable compressor
    this.isLoading = false; // Overall loading state
    this.loadingPhase = null; // Specific phase: 'audio', 'waveform', or null
  }

  /**
   * Set the time offset and update sample offset to match
   * @param {number} timeOffset - Time offset in seconds
   */
  setTimeOffset(timeOffset) {
    this.timeOffset = timeOffset;
    if (this.audioBuffer) {
      // Use original sample rate if available, otherwise fall back to audioBuffer sample rate
      const sampleRate = this.originalSampleRate || this.audioBuffer.sampleRate;
      this.sampleOffset = Math.round(timeOffset * sampleRate);
    }
  }

  /**
   * Set the sample offset and update time offset to match
   * @param {number} sampleOffset - Sample offset in this track's sample rate
   */
  setSampleOffset(sampleOffset) {
    this.sampleOffset = sampleOffset;
    if (this.audioBuffer) {
      // Use original sample rate if available, otherwise fall back to audioBuffer sample rate
      const sampleRate = this.originalSampleRate || this.audioBuffer.sampleRate;
      this.timeOffset = sampleOffset / sampleRate;
    }
  }
}
